<ng-container *ngIf="transactions$ | async as transactions">
  <ng-container *ngIf="transactions$ | async as transactions">
    <div *ngFor="let day of transactions | keyvalue: keepOrder">
      <h5 class="transaction-date mt-3 text-black text-uppercase">{{ day.key }}</h5>
      <div class="mb-0 mb-lg-4">
        <div class="card my-2 py-2 px-3" *ngFor="let transaction of day.value">
          <div class="row">
            <div class="col-8 text-start">
              <div class="fw-bold text-black transaction-text font-size-14 mb-1">
                {{ transaction.TransactionDescription }}
              </div>

              <div class="transaction-subtext fw-bold text-info">
                {{ transaction.TransactionDateUTC | UtcToLocaltimePipe: 'hh:mm a' | uppercase }}
              </div>
            </div>
            <div class="col-4 justify-content-end d-flex align-items-center">
              <div
                class="transaction-text text-capitalize fw-bold font-size-12"
                [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
              >
                {{ transaction.Amount >= 0 ? '+' : ''
                }}{{ transaction.Amount | FortressCurrencyPipe: (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        ((!transactions || !hasTransactions) && transactionType === transactionTypes.loyalty) ||
        ((!transactions || !hasTransactions) && transactionType === transactionTypes.ecash)
      "
    >
      <div class="no-items w-100 text-center border rounded py-4 mt-4 bg-white">
        <div class="svg ms-auto me-auto" fgbAnimateSvg>
          <img [src]="'placeholders/activity.svg' | contentAssetImage" alt="" />
        </div>
        <p class="text-black text-center font-size-14 mt-2 mb-0">
          {{ 'account.activity.placeholder.history.description' | translate }}
        </p>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
